/* eslint-disable no-empty-pattern */

import type {
  IGetEventType,
  IGetFileTypes,
  IGetMetrics,
  IGetMetricsParam
} from '../../API/processingDashboard'
import type { IStatusMap, IStatuses, MetricsLine, NotificationType } from '../../interfaces'
import type { AxiosResponse } from 'axios'

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import $api, { metrics } from '../../API'
import {
  messageErrorDashboardData,
  messageErrorDashboardEventType,
  messageErrorDashboardFilterType
} from '../../models/const'

export interface IMetricsSlice {
  data: MetricsLine[]
  isLoading: boolean
  count: number
  fileType: IStatuses[]
  eventType: IStatuses[]
  eventTypeMapping: IStatusMap
  notification: {
    message: string
    status: NotificationType | null
  }
}
const initialState: IMetricsSlice = {
  data: [],
  isLoading: false,
  count: 0,
  fileType: [],
  eventType: [],
  eventTypeMapping: {},
  notification: {
    message: '',
    status: null
  }
}
export const fetchData = createAsyncThunk('metrics/fetchTable', async (param: IGetMetricsParam) => {
  try {
    const response = await $api
      .get<IGetMetrics>(`${metrics}/getData`, { params: param })
      .then((response: AxiosResponse) => {
        return { data: response.data.data, count: response.data.count, status: response.status }
      })
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
})
export const fetchFileType = createAsyncThunk('metrics/fetchFileType', async () => {
  try {
    const response = await $api
      .get<IGetFileTypes[]>(`${metrics}/getMetricsFileTypes`)
      .then((response: AxiosResponse) => {
        return response.data.data
      })
    const returnStatus: IStatuses[] = response.map(
      (item: { id: unknown; fileTypeName: unknown }) => {
        return { id: item.id, statusName: item.fileTypeName }
      }
    )
    return returnStatus
  } catch (error) {
    console.error(error)
    throw error
  }
})
export const fetchEventType = createAsyncThunk('metrics/fetchEventType', async () => {
  try {
    const response = await $api
      .get<IGetEventType>(`${metrics}/getMetricsEventTypes`)
      .then((response: AxiosResponse<IGetEventType>) => {
        return response.data
      })
    return response
  } catch (error) {
    console.error(error)
    throw error
  }
})

export const metricsSlice = createSlice({
  name: 'metrics',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.isLoading = false
      state.count = Number(action.payload.count)
    })
    builder.addCase(fetchData.pending, state => {
      state.isLoading = true
    })
    builder.addCase(fetchData.rejected, state => {
      state.notification = { status: 'error', message: messageErrorDashboardData }
      state.isLoading = false
    })
    builder.addCase(fetchFileType.fulfilled, (state, action) => {
      state.fileType = action.payload
    })
    builder.addCase(fetchFileType.rejected, state => {
      state.notification = { status: 'error', message: messageErrorDashboardFilterType }
    })
    builder.addCase(fetchEventType.fulfilled, (state, action) => {
      state.eventType = action.payload.allTypes
      state.eventTypeMapping = action.payload.typesMapping
    })
    builder.addCase(fetchEventType.rejected, state => {
      state.notification = { status: 'error', message: messageErrorDashboardEventType }
    })
  }
})

export const {} = metricsSlice.actions
export default metricsSlice.reducer
